import { EventEmitter, Injectable } from "@angular/core";
import { Config } from "config/config";

declare var $: any;

@Injectable()
export class SignalRService {

    private proxy: any;
    private proxyName: string = 'messHub';
    private connection: any;
    public messageNoti: EventEmitter<any>;

    constructor() {
        // console.log(`constructor in SignalRService!!!!!!!!!!!!!!`);
    }

    public connectSignalR(): void {
        /*if (this.user.SuperAdmin) {
            return;
        }*/

        // Constructor initialization  
        this.messageNoti = new EventEmitter<any>();
        // this.connectionExists = false;

        // create hub connection
        this.connection = $.hubConnection(Config.url);
        this.connection.qs = { "access_token": localStorage.getItem("scnntttoken") };//, "id_coquan": 121 };
        //this.connection.qs = { "id_co_quan": auth.user.IdCoQuan };
        this.connection.error(function (error) {
            console.log('SignalR error: ' + error)
        });
        this.connection.disconnected(() => {
            setTimeout(() => {
                console.log('reconnect on disconnected');
                this.startConnection();
            }, 5000);
        });
        // create new proxy as name already given in top  
        this.proxy = this.connection.createHubProxy(this.proxyName);
        // register on server events  
        this.registerOnServerEvents();
        // call the connecion start method to start the connection to send and receive events.  
        this.startConnection();
    }

    private startConnection(): void {
        this.connection.start().done((data: any) => {
            console.log('Now connected ' + data.transport.name + ', connection ID= ' + data.id);
            // this.connectionEstablished.emit(true);
            // this.connectionExists = true;
            this.setConnectionState('1');
            // this.proxy.invoke('SendCoQuanChatList', this.user.IdCoQuan);
        }).fail((error: any) => {
            console.log('Could not connect ' + error);
            // this.connectionEstablished.emit(false);
        });
    }

    public disconnected(): void {
        try {
            if (this.getConnectionState() == '1') {
                // server side hub method using proxy.invoke with method name pass as param  
                this.proxy.invoke('DoLogout');
                // this.connectionExists = false;
                this.setConnectionState('0');
                // this.connection.stop();
                // .done(() => {
                //   console.log('stop connection')
                // });
            }
        } catch (e) { }
        finally {
            this.setConnectionState('0');
        }
    }

    private registerOnServerEvents(): void {
        //debugger;
        this.proxy.on('messageNoti', (data) => {
            this.messageNoti.emit(data);
        });
    }

    setConnectionState(value) {
        localStorage.setItem("_conn_", value);
    }

    getConnectionState() {
        return localStorage.getItem("_conn_") || "0";
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/services/signalR.service.ts